export default {
  data () {
    return {
      isLoadingData: false,
      errorLoadingData: false,
    };
  },
  methods: {
    retrieveData () {},
    setDataLoading () {
      this.isLoadingData = true;
    },
    setDataLoaded () {
      this.isLoadingData = false;
    },
    setErrorOnLoadingData () {
      this.errorLoadingData = true;
    },
    resetErrorOnLoadingData () {
      this.errorLoadingData = false;
    },
  },
  mounted () {
    this.retrieveData();
  },
};
